export const sentryProjectId = '4508620429590528';
export const sentryAuthToken = 'd2060cccdb87b6e162c4800fe356b566';


export const posthogProjectId = 'phc_PNLISAd3Xvi3NTftCZfX1Eg0C15Te6w4TNvqMAjVcFD';
